import { html, rune, type Html, View } from 'rune-ts';
import klass from './PromotionSection.module..scss';
import { getResizedUrl } from '../../../../../shared/util/image';
import { typoPcMo } from '../../../../../shared/typography/typo';
import { PromotionTooltip } from './PromotionTooltip';
import { ListMarkIcon } from '../../../../../shared/components/atoms/Icon';

export class PromotionSection extends View {
  left_days: number;
  constructor() {
    super({});

    const today = new Date();
    const apr1 = new Date(today.getFullYear(), 3, 1);
    const diffInMilliseconds = apr1.getTime() - today.getTime();
    this.left_days = Math.ceil(diffInMilliseconds / (1000 * 60 * 60 * 24));
  }

  override template(): Html {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    const texts = {
      sub_title: ' 지금 핸드메이드 크리에이터 신청하면',
      title: is_mobile ? html.preventEscape(`2025년 <br/>판매 수수료 0%`) : ' 2025년 판매 수수료 0%',
      desc_sub_title: '내 작품 수익의 100%가 내 몫!',
      desc_title_1: '핸드메이드 크리에이터',
      desc_title_2: '판매 수수료 0%',
      detail_item_header_1: '이벤트 기간',
      detail_item_header_2: '이벤트 대상',
      detail_item_header_3: '이벤트 혜택',
      detail_item_header_4: '혜택 적용 기간',
      detail_item_body_1: '2025년 1월 13일 ~ 3월 31일까지',
      detail_item_body_2: is_mobile
        ? html.preventEscape(`기간 내 핸드메이드 크리에이터<br/>신청을 완료한 분들`)
        : '기간 내 핸드메이드 크리에이터 신청을 완료한 분들',
      detail_item_body_3: '크리에이터배송 상품의 판매 수수료 0% 적용',
      detail_item_body_4: is_mobile
        ? html.preventEscape(`마플샵 판매 승인 시점 ~ <br/>2025년 12월 31일까지`)
        : '마플샵 판매 승인 시점 ~ 2025년 12월 31일까지',
      info_1: '※ PG사 수수료 3.2%(VAT 별도)는 별도 부과됩니다.',
      info_2: '※ 3월 31일 이후 신청시, 수수료 0% 혜택이 적용되지 않습니다.',
    };

    return html`
      <section class="${klass.container}">
        <div class="${klass.main_image_container}">
          <div class="${klass.image_wrapper}">
            <img
              class="${klass.background}"
              src="${getResizedUrl({
                url: is_mobile
                  ? '//s3.marpple.co/files/u_4648126/2024/12/original/025b9d77dd6c1a829164691fa69157bb6a366c9c1.png'
                  : '//s3.marpple.co/files/u_4648126/2024/12/original/99ac8d89c696482e48feaf385fc43c49c68ec80c1.png',
                format: 'webp',
                width: 708 * 2,
                quality: 85,
              })}"
              alt="핸드메이드 이벤트 배경 이미지"
            />
          </div>
        </div>
        <div class="${klass.content_container}">
          <div class="${klass.title_container}">
            <div class="${klass.title_wrapper}">
              <div class="${klass.sub_title} ${typoPcMo({ is_mobile, pc: '32_bold', mo: '16_bold' })}">
                ${texts.sub_title}
              </div>
              <div class="${klass.main_title} ${typoPcMo({ is_mobile, pc: '72_bold', mo: '40_bold' })}">
                ${texts.title}
              </div>
            </div>
            <div class="${klass.date_info} ${typoPcMo({ is_mobile, pc: '16_bold', mo: '14_bold' })} ">
              이벤트 종료까지 ${this.left_days}일 남았습니다
            </div>
          </div>
          <div class="${klass.desc_container}">
            <div class="${klass.image_container}">
              <img
                src="//s3.marpple.co/files/u_4648126/2024/12/original/e29642349d9f94730b72e4f68bf7c9d42caa15241.png"
                alt=""
              />
            </div>
            <div class="${klass.desc_wrapper}">
              <div class="${klass.detail_title_wrapper}">
                <div
                  class="${klass.detail_sub_title} ${typoPcMo({ is_mobile, pc: '16_bold', mo: '14_bold' })}"
                >
                  ${texts.desc_sub_title}
                </div>
                <div
                  class="${klass.detail_title_list} ${typoPcMo({ is_mobile, pc: '28_bold', mo: '20_bold' })}"
                >
                  <div>${texts.desc_title_1}</div>
                  <div class="${klass.detail_title}">${texts.desc_title_2}</div>
                </div>
              </div>
              <div class="${klass.detail_list} ${typoPcMo({ is_mobile, pc: '16_medium', mo: '14_medium' })}">
                <div class="${klass.detail_item}">
                  <span
                    class="${klass.detail_item_header} ${typoPcMo({
                      is_mobile,
                      pc: '14_bold',
                      mo: '12_bold',
                    })}"
                    >${texts.detail_item_header_1}</span
                  >
                  <span class="${klass.detail_item_body}">${texts.detail_item_body_1}</span>
                </div>
                <div class="${klass.detail_item}">
                  <span
                    class="${klass.detail_item_header} ${typoPcMo({
                      is_mobile,
                      pc: '14_bold',
                      mo: '12_bold',
                    })}"
                    >${texts.detail_item_header_2}</span
                  >
                  <span class="${klass.detail_item_body}">${texts.detail_item_body_2}</span>
                </div>
                <div class="${klass.detail_item}">
                  <span
                    class="${klass.detail_item_header} ${typoPcMo({
                      is_mobile,
                      pc: '14_bold',
                      mo: '12_bold',
                    })}"
                    >${texts.detail_item_header_3}</span
                  >
                  <span class="${klass.detail_item_body}">${texts.detail_item_body_3}</span>
                </div>
                <div class="${klass.detail_item}">
                  <span
                    class="${klass.detail_item_header} ${typoPcMo({
                      is_mobile,
                      pc: '14_bold',
                      mo: '12_bold',
                    })}"
                    >${texts.detail_item_header_4}</span
                  >
                  <span class="${klass.detail_item_body}">${texts.detail_item_body_4}</span>
                </div>
              </div>
              <div
                class="${klass.sub_detail_list} ${typoPcMo({
                  is_mobile,
                  pc: '14_medium',
                  mo: '12_medium',
                })}"
              >
                <div class="${klass.sub_detail_item}">${texts.info_1}</div>
                <div class="${klass.sub_detail_item}">${texts.info_2}</div>
              </div>
              ${new PromotionTooltip({
                id: 'handmade-tooltip',
                content: this.getCautionTooltipBody(),
                contentClass: klass.caution_body,
                placement: is_mobile ? 'top' : 'top-start',
              })}
            </div>
          </div>
        </div>
      </section>
    `;
  }

  getCautionTooltipBody() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    return html`
      <div
        class="${typoPcMo({
          is_mobile,
          pc: '14_medium',
          mo: '12_medium',
        })}"
      >
        <div class="${klass.caution_item}">
          ${ListMarkIcon} 핸드메이드 크리에이터배송 상품 판매 수수료 0% 프로모션은 2025년 1월 13일부터 2025년
          3월 31일까지 마플샵 크리에이터 신청을 완료한 핸드메이드 크리에이터를 대상으로 진행됩니다.
        </div>
        <div class="${klass.caution_item}">
          ${ListMarkIcon} 본 프로모션의 혜택 적용 기간은 판매 승인 시점부터 2025년 12월 31일까지입니다.
        </div>
        <div class="${klass.caution_item}">
          ${ListMarkIcon} 본 프로모션은 크리에이터가 직접 제작 및 배송하는 '크리에이터배송 상품' 판매 수익에만
          적용됩니다.
        </div>
        <div class="${klass.caution_item}">
          ${ListMarkIcon} 다음과 같은 경우, 프로모션 혜택이 적용되지 않습니다.
        </div>
        <div class="${klass.caution_item} ${klass.caution_item_sub}">
          ${ListMarkIcon} 프로모션 기간 이후, 크리에이터 신청을 완료한 경우
        </div>
        <div class="${klass.caution_item} ${klass.caution_item_sub}">
          ${ListMarkIcon} 프로모션 기간 이전, 이미 핸드메이드 크리에이터로 신청하여 마플샵 판매 승인이 완료된
          경우
        </div>
        <div class="${klass.caution_item} ${klass.caution_item_sub}">
          ${ListMarkIcon} 핸드메이드가 아닌 다른 카테고리의 크리에이터일 경우
        </div>
      </div>
    `;
  }
}
